/*
 * Copyright © 2018, Rezo Zero
 *
 * @file HomePage.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import Page from './Page'
import {
    TweenLite,
    TimelineLite,
    Expo
} from 'gsap'
import { $window } from '../utils/environment'

/**
 * HomePage.
 *
 * @extends {AbstractPage}
 * @private
 */
export default class HomePage extends Page {
    constructor (router, container, context, type) {
        super(router, container, context, type)

        // Elements
        this.$introduction = this.$cont.find('#introduction')
        this.$introductionDescription = this.$introduction.find('#introduction-description')
        this.$listing = this.$cont.find('#interview-list')
        this.$scrollBtn = this.$cont.find('#scroll-btn')

        // Binded methods
        this.onScrollbtnClick = this.onScrollbtnClick.bind(this)
    }

    init () {
        super.init()

        this.previousPage = window.previousPage
        window.previousPage = 'homepage'

        if (this.previousPage === 'interview') {
            $window.triggerHandler('background.black')
            $window.triggerHandler('bubble.reduceOpacity')
        } else {
            $window.triggerHandler('background.white')
            $window.triggerHandler('bubble.resetOpacity')
        }
    }

    scrollInitiated () {
        if (this.previousPage === 'interview') {
            this.scrollToBottom(1)
        }
    }

    initEvents () {
        super.initEvents()
        this.$scrollBtn.on('click', this.onScrollbtnClick)
    }

    destroyEvents () {
        super.destroyEvents()
        this.$scrollBtn.off('click', this.onScrollbtnClick)
    }

    onInViewScroll (e) {
        super.onInViewScroll(e)

        if (this.locked) return

        if (e.type === 'inview' && e.options && e.options.backgroundColor !== undefined) {
            if (e.way === 'enter') {
                $window.triggerHandler('background.black')
                $window.triggerHandler('bubble.center')
                $window.triggerHandler('bubble.reduceOpacity')
            } else if (e.way === 'leave') {
                $window.triggerHandler('background.white')
                $window.triggerHandler('bubble.randomSplit')
                $window.triggerHandler('bubble.resetOpacity')
            }
        }
    }

    onScrollbtnClick () {
        this.scrollToBottom()
    }

    scrollToBottom (duration = 1000) {
        $window.triggerHandler('scroll.scrollTo', {
            positions: {
                x: 0,
                y: window.innerHeight * 1.15,
                duration
            }
        })
    }

    staticLoad () {
        this.showIntroduction()
    }

    transitionComplete () {
        this.showIntroduction()
    }

    showIntroduction () {
        const tl = new TimelineLite()
        const descriptionSplitText = new window.SplitText(this.$introductionDescription, {
            type: 'lines',
            lineClass: 'line++'
        })
        const lines = descriptionSplitText.lines

        tl
            .staggerFrom(lines, 1, {
                opacity: 0,
                y: 80,
                ease: Expo.easeOut
            }, 0.05, '+=0')

        TweenLite.set(this.$introductionDescription, { autoAlpha: 1 })
    }
}



// WEBPACK FOOTER //
// ./webpack/js/pages/HomePage.js